import {openMail} from 'shared/lib/links'
import {Button} from 'shared/ui/buttons'

export const OpenMailButton = () => {
  return (
    <Button
      type='button'
      fullwidth
      styleType='primary'
      onClick={openMail}
    >
      Open email
    </Button>
  )
}